import React, { Component } from "react";

import { withAuthorization } from "../Session";
import UsersTable from "./UsersTable";
import Toast from "./../common/toast";

class ListUsers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      dealerAddStatus: false,
      customers: []
    };
  }

  componentDidMount() {
    console.log(
      "componentDidMount(): customers: ",
      this.props.firebase.customers()
    );
    this.setState({ loading: true });
    this.setState({ dealerAddStatus: true });

    this.props.firebase.customers().on("value", snapshot => {
      const customersObject = snapshot.val();

      const customersList = Object.keys(customersObject).map(key => ({
        ...customersObject[key],
        uid: key
      }));
      this.setState({ customers: customersList, loading: false });
      this.setState({ dealerAddStatus: false });
      console.log("All Customers: ", customersList);
    });
  }
  componentWillUnmount() {
    console.log("in componentWillUnmount: Customers: ", this.state.customers);
    this.props.firebase.customers().off();
  }

  render() {
    const { customers, loading, sortColumn, dealerAddStatus } = this.state;
    console.log("in ListUsers: Customers: ", { customers });
    return (
      <div>
        {loading && <div>Loading ...</div>}
        {dealerAddStatus && (
          <Toast toastTitle="" toastTitleRight="" toastMessage="" />
        )}
        <UsersTable
          customers={customers}
          onSort={this.handleSort}
          sortColumn={sortColumn}
        />
      </div>
    );
  }
}
const condition = authUser => !!authUser;

export default withAuthorization(condition)(ListUsers);

//export default withFirebase(ListUsers);
